<template>
  <div class="rightNav" ref="rightNav">
    <div class="login_wrap" v-if="!isLogin">
      <div class="title">
        <img src="@/assets/img/icon_register.png" class="img" />
        登录/注册 入口
      </div>
      <template>
        <div id="ChangeLoginType">
          <el-radio v-model="loginType" label="0" @change="fnChangeLoginType">普通登录</el-radio>
          <el-radio v-model="loginType" label="1" @change="fnChangeLoginType">供应商CA证书登录</el-radio>
        </div>
        <!-- <div>
          <el-radio-group v-model="loginType" @change="fnChangeLoginType">
            <el-radio label="0">普通登录</el-radio>
            <el-radio label="1">供应商CA证书登录</el-radio>
          </el-radio-group>
        </div>-->
      </template>
      <div class="content">
        <div v-if="loginType == '0'">
          <el-input placeholder="请输入登录账号或手机号" v-model="username"></el-input>
          <el-input placeholder="请输入登录密码" v-model="password" show-password type="password" @change="loginEvents"></el-input>
        </div>
        <div v-if="loginType == '1'">
          <el-input v-model="CAname" readonly="readonly"></el-input>
          <el-input placeholder="请输入证书密码" v-model="CApwd" show-password type="password" @change="loginEvents"></el-input>
        </div>

        <div class="text clear">
          <!-- <span @click.stop="toAboutUs">常见问题</span> -->
          <span class="fr" @click.stop="passwordEvents">忘记密码></span>
        </div>
        <div class="btn_wrap">
          <span class="btn_1 btn_reg" @click.stop="registerEvents">注册</span>
          <span class="btn_1" @click.stop="loginEvents">登录</span>
        </div>
      </div>
      <!-- <div class="content" v-if="loginType=='1'">
        <el-input v-model="CAname" readonly="readonly"></el-input>
        <el-input placeholder="请输入证书密码" v-model="CApwd" show-password type="password"></el-input>
        <div class="text clear">
           TODO：添加忘记密码更改链接
          <span class="fr">忘记密码></span>
        </div>
        <div class="btn_wrap">
           <span class="btn_1 btn_reg" @click.stop="registerEvents">注册</span>
          <span class="btn_1" @click.stop="loginEvents">登录</span>
        </div>
      </div>-->
    </div>
    <div class="logined_wrap" v-else>
      <div class="title clear">
        <span>{{ loginInfos.supplierName }}</span>
        <span class="fr" @click.stop="exitEvents">【退出】</span>
      </div>
      <ul class="list">
        <li>
          <img src="@/assets/img/icon_contacts.png" />
          <span>
            <label class="labell">联系人：</label>
            {{ loginInfos.name }}（{{ loginInfos.tel }}）
          </span>
        </li>
        <li>
          <img src="@/assets/img/icon_effectivedate.png" />
          <span>
            <label class="labell">有效日期：</label>
            {{ loginInfos.date }}
          </span>
        </li>
      </ul>
      <div class="btn">
        <span class="btn_1" @click.stop="goMember">
          进入会员中心
          <img src="@/assets/img/icon_getinto.png" class="img" />
        </span>
      </div>
    </div>
    <div class="border_wrap" v-if="noticeList.isShow">
      <div class="title">{{ noticeList.title }}</div>
      <ul class="li_wrap">
        <li v-for="(item, index) in noticeList.list" :key="index" @click.stop="goDetail(item.id, noticeId, 0)">
          <span class="li_left">{{ item.title }}</span>
          <span class="li_right">{{ item.date }}</span>
        </li>
      </ul>
      <div class="foot" @click.stop="more('#/Server')">更多></div>
    </div>
    <div class="swiper-container reportImg" :style="width">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in advertList" :key="index">
          <img :src="baseURL + item.imgUrl" @click.stop="goAdvertist(item.link)" />
          <div class="text_new"></div>
        </div>
      </div>

      <div class="swiper-pagination"></div>
    </div>
    <div class="border_wrap" v-if="supplierList.isShow">
      <div class="title">{{ supplierList.title }}</div>
      <ul class="li_wrap">
        <li v-for="(item, index) in supplierList.list" :key="index" @click.stop="goDetail(item.id, supplierId, 0)">
          <span class="li_left">{{ item.title }}</span>
          <span class="li_right">{{ item.date }}</span>
        </li>
      </ul>
      <div class="foot" @click.stop="more('#/Supplier')">更多></div>
    </div>
    <div class="border_wrap" v-if="downLloadList.isShow">
      <div class="title">{{ downLloadList.title }}</div>
      <ul class="li_wrap">
        <!-- <li v-for="item in downLloadList.files"><span class="li_left">{{item}}</span></li> -->
        <li v-for="(item, index) in downLloadList.files" :key="index" @click.stop="goDetail(item.id, serviceId, 0)">
          <span class="li_left">{{ item.title }}</span>
          <span class="li_right">{{ item.date }}</span>
        </li>
      </ul>
      <!-- <div class="foot" @click.stop="$router.push('/Server')">更多></div> -->
      <div class="foot" @click.stop="more('#/Server')">更多></div>
    </div>
    <SupplierNote :dialogvisible.sync="dialogvisible" :messageData="messageData"></SupplierNote>
  </div>
</template>

<script>
import SupplierNote from './SupplierNote.vue'
import Swiper from '@/assets/js/swiper.min.js'
import jsSHA from '@/assets/js/sha.js'
// import {mapState,mapMutations} from "vuex";
export default {
  components: {
    SupplierNote
  },
  name: 'Radio',
  data() {
    return {
      random: '',
      randomSign: '',
      certification: '',
      timer: '',
      CertId: '',
      CAname: '',
      CApwd: '',
      loginType: '0',
      dataInitial: {},
      width: { width: '' },
      advertList: [],
      supplierId: '',
      noticeId: '',
      serviceId: '',
      isLogin: false, //是否登录
      approve: true, //是否审核通过
      loginInfos: {
        supplierName: '广州天天开心有限公司',
        name: '张晓丽',
        tel: '13800138000',
        date: '2020-06-23'
      },
      username: '',
      password: '',
      reportImg: require('../assets/img/test1.jpg'),
      supplierList: {
        title: '供应商招募',
        list: [],
        isShow: false
      },
      downLloadList: {
        title: '资料下载',
        files: [],
        isShow: true
      },
      noticeList: {
        title: '通知公告',
        list: [],
        isShow: true
      },
      messageData: [],
      dialogvisible: false
    }
  },
  props: {
    inidata: {
      type: Object
    }
  },
  watch: {
    inidata: function (newVal, oldVal) {
      this.initialList = newVal
      var type = this.initialList.purchaseTypes[0].Value
      if (this.initialList.supplier != null) {
        this.supplierId = this.initialList.supplier.Id
        this.getList(this.supplierId, type, 3, 0)
      } else {
        this.supplierList.isShow = false
      }
      var serviceId = ''
      if (this.initialList.service != null) {
        this.serviceId = this.initialList.service.Id
        this.getList(this.serviceId, type, 5, 1)
      } else {
        this.downLloadList.isShow = false
      }
      var noticeId = ''
      if (this.initialList.notice != null) {
        this.noticeId = this.initialList.notice.Id
        this.getList(this.noticeId, type, 5, 2)
      } else {
        this.noticeList.isShow = false
      }
    },
    isLogin: function (newVal, oldVal) {
      console.log(newVal)
      if (newVal == true) {
        this.fnGetNotice()
      }
    }
  },
  mounted() {
    window.init(
      function () {
        window.console.log('sucess')
      },
      function () {
        window.console.log('fail')
      }
    )
    // window.SOF_GetUserList(data => {
    //     window.console.log(data);
    //     window.console.log(data.retVal);
    //     var UserListStr = data.retVal;
    //     // window.console.log(data.retVal);
    //     var arr = UserListStr.split("&&&");
    //     // this.certs = new Array();
    //     this.CAname = arr[0].split("||")[0];
    //     window.console.log(this.CAname);
    //     this.CertId = arr[0].split("/")[1];
    //     window.console.log(this.CertId);
    //     // for (var index = 0; index < arr.length; index++) {
    //     //   var Belong = arr[index].split("||")[0]; //电子合同个人测试6||998000100204344/5303201807021399(证书所有者||密码卡序列号/USB-key序列号)
    //     //   var u_key = arr[index].split("/")[1];
    //     //   var obj = {};
    //     //   obj.text = Belong;
    //     //   obj.value = u_key;
    //     //   this.certs.push(obj);
    //     // }
    //     clearTimeout(this.timer);
    //     return;
    //   });

    this.AdvertisingList()
    this.swiperInit()
    this.widthCom()
    let token = window.localStorage.getItem('loginToken')
    if (token != null && token != '') {
      this.DefaultLogin()
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    fnGetNotice() {
      this.getRequest('SupplierLogin/GetNotice')
        .then((res) => {
          if (res.data.errcode == 0) {
            if (res.data.hasMessage == true) {
              this.messageData = res.data.messageData
              this.dialogvisible = true
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnBinding() {
      if (this.CertId == undefined || this.CertId == null) {
        this.$message.error('请选择有效CA UKey')
        return
      }
      window.SOF_ExportUserCert(this.CertId, (data) => {
        var usercert = data.retVal
        window.SOF_GetCertEntity(usercert, (data1) => {
          var CACode = data1.retVal

          var beginDate
          var endDate
          SOF_GetCertInfo(usercert, 11, (data2) => {
            beginDate = data2.retVal
            SOF_GetCertInfo(usercert, 12, (data3) => {
              endDate = data3.retVal

              let config = {
                params: {
                  CartBandCode: CACode,
                  BeginDate: beginDate,
                  EndDate: endDate,
                  CACertOwner: this.CAname
                }
              }

              this.getRequest('/Purchase/BindingCA', config).then((res) => {
                if (res.data.errcode == 0) {
                  // this.$message.success('成功绑定!')
                  // setTimeout(() => {
                  //   window.close()
                  // }, 2000)
                } else {
                  this.$message.error(res.data.errmsg)
                }
              })
            })
          })
        })
      })

      //TODO:调用后台获取当前密钥
    },
    fnCALogin() {
      //5、调用DSVS接口

      // window.SOF_GetCertEntity(
      //   UserCert,
      //   data => {
      //     identification = data.retVal;
      //     //TODO:后台验证登录
      //     window.console.log(
      //       identification
      //     );
      //   }
      // );
      let pwdValidate = false
      this.getRequest('/SupplierLogin/GetCAInfo').then((res) => {
        if (res.data.errcode == 0) {
          this.random = res.data.Random //随机数
          this.randomSign = res.data.RandomSign //随机数标识
          this.certification = res.data.Certification //证书

          //6、用户输入密码，应用系统验证口令
          window.SOF_Login(this.CertId, this.CApwd, (data) => {
            if (data.retVal) {
              pwdValidate = true
            } else {
              pwdValidate = false
            }
            // else {
            //   this.$message({ type: "fail", message: "登录密码错误!" });
            // }
            window.SOF_VerifySignedData(
              //验证服务器端随机数签名值
              this.certification,
              this.random,
              this.randomSign,
              (data) => {
                if (data.retVal) {
                  //验证服务器证书有效性
                  window.SOF_ValidateCert(this.certification, (data) => {
                    if (data.retVal == 0) {
                      //应用系统调用XTX服务队随机数进行签名
                      //1、导出用户证书
                      window.SOF_ExportUserCert(this.CertId, (data) => {
                        var UserCert = data.retVal

                        window.SOF_GetCertEntity(UserCert, (data) => {
                          var identification = data.retVal
                          //2、数字签名
                          window.SOF_SignData(this.CertId, this.random, (data) => {
                            var NumSign = data.retVal

                            let config = {
                              params: {
                                strCert: UserCert,
                                random: this.random,
                                signVal: NumSign,
                                certId: this.CertId,
                                CartCode: identification,
                                pwdValidate: pwdValidate
                              }
                            }
                            this.getRequest('/SupplierLogin/CALoginVerify', config).then((res) => {
                              if (res.data.errcode == 0) {
                                //调用服务
                                this.hideLoading()
                                this.approve = res.data.isAudit //是否通过审核
                                var sysNo = res.data.sysNo //审核详细外键
                                localStorage.setItem('loginToken', res.data.loginToken)
                                if (!res.data.isRegister) {
                                  //如果没注册跳转注册页面
                                  this.$message(res.data.resultData)
                                  // that.registerEvents();
                                } else {
                                  //已经注册过
                                  if (this.approve) {
                                    //判断是否通过审核,审核通过可登录
                                    this.loginInfos.supplierName = res.data.supplierName
                                    this.loginInfos.name = res.data.contact
                                    this.loginInfos.tel = res.data.mobile
                                    this.loginInfos.date = res.data.entryValidTerm
                                    this.isLogin = true
                                    this.fnBinding()
                                  } else {
                                    //审核不通过查看审核进度
                                    this.$router.push({
                                      //传外键值到审核进度详细页面
                                      path: '/result',
                                      query: { sysNo: sysNo }
                                    })
                                  }
                                }

                                //获取用户唯一标识
                              } else {
                                this.$message.error(res.data.errmsg)
                              }
                            })
                          })
                        })
                      })
                    } else {
                      switch (data.retVal) {
                        case -1:
                          this.$message.error('服务器证书出错：证书不被信任')
                          break
                        case -2:
                          this.$message.error('服务器证书出错：超过有效期范围')
                          break
                        case -3:
                          this.$message.error('服务器证书出错：证书已作废')
                          break
                        case -4:
                          this.$message.error('服务器证书出错：证书已冻结')
                          break
                        case -5:
                          this.$message.error('服务器证书出错：证书未生效')
                          break
                        case -6:
                          this.$message.error('服务器证书出错：其他错误')
                          break
                      }
                    }
                  })
                } else {
                  this.$message({ type: 'fail', message: '安全验证未通过!' })
                }
              }
            )
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnUpdateCA() {
      window.console.log('定时服务开始执行')
      window.SOF_GetUserList((data) => {
        var UserListStr = data.retVal
        // window.console.log(data.retVal);
        var arr = UserListStr.split('&&&')
        // this.certs = new Array();
        this.CAname = arr[0].split('||')[0]
        this.CertId = arr[0].split('/')[1]
        // for (var index = 0; index < arr.length; index++) {
        //   var Belong = arr[index].split("||")[0]; //电子合同个人测试6||998000100204344/5303201807021399(证书所有者||密码卡序列号/USB-key序列号)
        //   var u_key = arr[index].split("/")[1];
        //   var obj = {};
        //   obj.text = Belong;
        //   obj.value = u_key;
        //   this.certs.push(obj);
        // }
        // clearTimeout(this.timer);
        return
      })

      this.timer = setTimeout(this.fnUpdateCA, 5000)
    },
    fnChangeLoginType(value) {
      window.console.log(value)
      if (value == 1) {
        window.console.log('定时服务启动')
        this.fnUpdateCA()
        this.timer = setTimeout(this.fnUpdateCA, 5000)
      } else {
        window.console.log('定时服务停止')
        clearTimeout(this.timer)
      }
    },
    goAdvertist(url) {
      window.open(url, '_blank')
    },
    widthCom() {
      let heigh = this.$refs.rightNav.offsetWidth
      this.width.width = heigh + 'px'
    },
    AdvertisingList() {
      let that = this
      this.getRequest('/Information/AdvertisingList')
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            that.advertList = data.advertList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getList(cateId, type, showNum, listType) {
      var that = this
      let config = {
        params: {
          cateId: cateId,
          purchaseType: type,
          showNum: showNum
        }
      }
      this.getRequest('/Information/GetPart', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            if (listType == 0) {
              that.supplierList.list = data.infoList
            } else if (listType == 1) {
              that.downLloadList.files = data.infoList
            } else if (listType == 2) {
              that.noticeList.list = data.infoList
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    downLoad(id, url) {
      let that = this
      that.downloadfile(that.baseURL + url)
    },
    registerEvents() {
      this.$router.push('/policy')
    },
    passwordEvents() {
      this.$router.push('/password')
    },
    toAboutUs() {
      this.$router.push({ name: 'aboutUs' })
    },
    loginEvents() {
      console.log(3333333333)
      if (this.loginType == 0) this.login()
      else if (this.loginType == 1) this.fnCALogin()
    },
    login() {
      var that = this

      if (this.username == '' || this.password == '') {
        that.$message('用户名和密码不能为空！')
        return
      }

      var username = this.username
      var password = this.password
      // var loginPwd = $("#LoginPwd").val();
      var shaObj = new jsSHA(password, 'TEXT')
      var loginPwdHash = shaObj.getHash('SHA-1', 'HEX')
      console.log(loginPwdHash)
      // $("#LoginPwd").val(loginPwdHash);

      var that = this
      var sysNo = ''
      this.postRequest('SupplierLogin/Login', {
        loginName: username,
        loginPwd: loginPwdHash
      })
        .then((res) => {
          var data = res.data
          that.showLoading()
          if (data.errcode == 0) {
            that.hideLoading()
            that.approve = data.isAudit //是否通过审核
            sysNo = data.sysNo //审核详细外键
            localStorage.setItem('loginToken', data.loginToken)
            if (!data.isRegister) {
              //如果没注册跳转注册页面
              that.$message(data.resultData)
              // that.registerEvents();
            } else {
              //已经注册过
              if (that.approve) {
                //判断是否通过审核,审核通过可登录
                that.loginInfos.supplierName = data.supplierName
                that.loginInfos.name = data.contact
                that.loginInfos.tel = data.mobile
                that.loginInfos.date = data.entryValidTerm
                that.isLogin = true
              } else {
                //审核不通过查看审核进度
                that.$router.push({
                  //传外键值到审核进度详细页面
                  path: '/result',
                  query: { sysNo: sysNo }
                })
              }
            }
          } else {
            this.$message.error(res.data.errmsg)
            that.hideLoading()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DefaultLogin() {
      var that = this
      var sysNo = ''

      this.postRequest('/SupplierLogin/DefaultLogin')
        .then((res) => {
          var data = res.data
          if (data.errcode != 2) {
            if (data.errcode == 0) {
              that.loginInfos.supplierName = data.supplierName
              that.loginInfos.name = data.contact
              that.loginInfos.tel = data.mobile
              that.loginInfos.date = data.entryValidTerm
              that.isLogin = true
            } else {
              this.$message.error(res.data.errmsg)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    exitEvents() {
      this.isLogin = false
      window.localStorage.removeItem('loginToken')
    },
    goMember() {
      this.$router.push('/MemberCenter')
    },
    swiperInit() {
      setTimeout(() => {
        var mySwiper = new Swiper('.swiper-container', {
          loop: true,
          autoplay: { disableOnInteraction: false, delay: 4000 },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            click: function () {}
          }
        })
      }, 800)
    },
    goDetail(id, cateId, purchaseType) {
      if (id) {
        let routerData = this.$router.resolve({
          name: 'detail',
          query: { id: id, cateId: cateId, purchaseType: purchaseType }
        })
        window.open(routerData.href, '_blank')
      }
    },
    more(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.rightNav {
  flex: 1;
  margin-left: 25px;
}
.login_wrap {
  border: 1px solid #2db7f5;
  margin-bottom: 10px;
  .title {
    height: 40px;
    line-height: 40px;
    background: #2db7f5;
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }
  .img {
    margin-right: 8px;
  }
  .content {
    padding: 10px;
    .text {
      color: #5a8cc7;
      margin-top: 7px;
      span {
        cursor: pointer;
      }
      span:nth-of-type(1) {
        margin-right: 15px;
      }
    }
    .btn_wrap {
      margin-top: 40px;
    }
  }
  .el-input {
    margin-bottom: 15px;
  }
  .el-input ::v-deep .el-input__inner {
    border: 1px solid #cccccc;
    color: #333;
  }
}
.logined_wrap {
  background: #c5e7f5;
  padding: 10px;
  border: 1px solid #2db7f5;
  margin-bottom: 10px;
  .title span:nth-of-type(1) {
    font-weight: bold;
  }
  .title span:nth-of-type(2) {
    color: #0774c5;
    cursor: pointer;
  }
  .btn {
    border-top: 1px dashed #2db7f5;
    padding-top: 10px;
    margin-top: 10px;
  }
  .btn_1 {
    width: 100%;
  }
  .img {
    margin-left: 30px;
  }
  .list {
    margin: 10px 0;
    li {
      padding: 5px 0;
      color: #666;
      .labell {
        font-weight: bold;
      }
      img {
        margin-right: 5px;
      }
    }
  }
}
.reportImg {
  margin-bottom: 10px;
  width: 300px;
  height: 100px;
}
.reportImg img {
  width: 100%;
  height: 100%;
}
.border_wrap .title2 {
  text-indent: 0.4em;
}
.el-icon-download {
  vertical-align: middle;
}
.el-icon-download:before {
  font-size: 22px;
}
.btn_reg {
  background: #fff;
}
.rule_form {
  margin-top: 0;
}
.rule_form .el-form-item {
  margin-bottom: 0;
}
#ChangeLoginType {
  padding: 15px 15px 3px 0;
  text-align: center;
}
</style>
